// 여러 페이지에서 배너 데이터를 한 번만 가져오고, TTL 동안 재사용.
const ttlMs = 60_000 // 1분
export const useBannerList = () => {
  const nuxtApp = useNuxtApp()
  return useAsyncData<EventList>('event-banners', async () => {
    try {
    const res = await useApi().eventApi.getBanners()
    if ('success' in res && res.success) {
      return res.data as EventList
    }
    throw new Error('Banner API returned fail')
  } catch (e) {
    throw e
  }
  }, {
    server: true,
    lazy: true,
    transform: (data) => ({ ...data, fetchedAt: Date.now() }),
    getCachedData: (key) => {
        const cached = (nuxtApp.payload?.data?.[key] ??
                        nuxtApp.static?.data?.[key])
        if (!cached) return undefined
        if (!cached.fetchedAt) return undefined
        const fresh = (Date.now() - cached.fetchedAt) < ttlMs
        return fresh ? cached : undefined     // 만료면 undefined → 새로 fetch
      }
  })
}